<template>
  <div class="swiper-card card-person">
    <div class="person">
      <span class="step">Biography</span>
      <h1>{{ slide.title }}</h1>
      <h2 v-if="bioObject && bioObject.meta  && bioObject.meta.byline !== ''">{{ bioObject.meta.byline }}</h2>
      <p v-if="bioObject && bioObject.meta && bioObject.meta.description !== ''">{{ bioObject.meta.description }}</p>
    </div>

    <!-- <h3>Why {{ slide.title }} is in the news</h3> -->

    <div v-for="(content, idx) in getBody" :key="idx" class="content-block">
      <h2 v-if="content.title">{{ content.title }}</h2>
      <!-- <div v-html="content.content"></div> -->
      <h3>What's happening?</h3>
      <p v-html="getStoryContent.what"></p>
      <h3>Why now?</h3>
      <p v-html="getStoryContent.why"></p>
      <h3>What next?</h3>
      <p v-html="getStoryContent.andso"></p>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      slide: {
        type: Object,
      },
      meta: {
        type: Object
      },
      stack: {
        type: Object,
      },
      stories: {
        type: Array,
      },
    },

    computed: {
      isAlpha() {
        return this.$store.getters.isAlpha;
      },

      getStoryContent() {
        return this.slide?.meta?.script;
      },

      bioObject() {
        // okay - for now, assume just the first story (should't be to in biography context)
        let sSlug = this.slide?.meta?.stories?.[0];
        let sWhoSlug = `stx_${sSlug}`;

        if (!sSlug) {
          return {};
        }
        // get out "who" object (contains the name + wiki slug)
        let oWho = this.slide?.meta?.extra?.[sWhoSlug]?.who;
        if (!oWho) {
          return {};
        }
        // find the story this is coming from ...
        let oStory = this.stories.filter((o) => {
          return o.slug == sSlug;
        }).shift();
        if (!oStory) {
          return {};
        }
        // now find the topic card (which we can assume is present in the story! :fingers_crossed:)
        let oTopic = oStory?.topics?.filter((t) => {
          // okay ... actually got topic_codes (which wasn't the expection... and probably unhelpful)
          // expect the API to change here slightly so ... here are a few catches (the middle one *should* be the charm)
          return (t.topic_code == oWho.wiki) || (t.meta_wiki == oWho.wiki) || (t.meta_wiki == `/wiki/${oWho.wiki}`);
        }).shift();

        return oTopic;
      },

      bioMeta() {
        return this.bioObject?.meta || {};
      },

      getBody() {
        const body = [...this.slide.content.body];
        const image = this.images[1];

        if (body.length > 0 && typeof body[0].content === 'string' && image) {
          const imageHTML = `
            <div class="image">
              <img src="${image.image}" alt="${image.caption}" />
              <p class="caption">${image.caption}</p>
            </div>`;

          body[0] = {
            ...body[0],
            content: body[0].content.replace(/(<([a-z][a-z0-9]*)[^>]*>)(.*?)(<\/\2>)/s, `$1$3$4${imageHTML}`)
          };
        }

        return body;
      },

      images () {
        let images = [];
        this.slide?.meta?.stories?.forEach(slug => {
          this.$store.getters.getStory(slug)?.articles?.forEach(article => {
            images.push({
              story: slug,
              article: article.slug,
              image: article.image,
              photo: article.photo,
              publisher: article.publisher,
              caption: article.name,
            });
          });
        });
        return images.filter(a => a.photo).sort( () => .5 - Math.random() );
      },
    },

    watch: {
      '$route.params.stack': {
        handler(slug) {
          if (slug === this.slide.slug) {
            // Hacky temporary solution, update the image within swiper. Remove it if not.
            // This ideally needs to be handled in swiper but we can't find/access that image without a ton of duplicated code
            if (this.bioObject && this.bioObject.meta && this.bioObject.meta.image !== "") {
              this.$emit('featureImage', this.bioObject.meta.image)
            } else {
              this.$emit('featureImage', null)
            }
          }
        },
        immediate: true,
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5_stacks.scss';

  .card-person {
    .desktop & {
      padding: 0 4rem 4rem 4rem;
    }
  }

  .person {
    z-index: 10;
    padding-bottom: 1.5rem;
    margin-bottom: 1.5rem;
    border-bottom: 1px solid $neutral-500;

    .darkmode & {
      border-bottom: 1px solid $neutral-300;
    }

    .step {
      display: inline-block;
      width: 100%;
      margin-bottom: 0.75rem;
      font-family: 'Circular';
      font-weight: bold;
      font-size: 0.9rem;
      color: $yellow-tone-4;

      .darkmode & {
        color: $yellow-tone-3;
      }

      .desktop & {
        font-size: 1.1rem;
      }
    }

    h1 {
      font-size: 2rem;

      .desktop & {
        font-size: 3rem;
      }
    }

    h2 {
      font-family: 'Colfax';
      font-weight: normal;
      font-size: 1.1rem;
      line-height: 140%;
      margin: 0 0 1rem 0;
      color: $neutral-300;

      .darkmode & {
        color: $neutral-400;
      }
    }

    p {
      font-size: 1.3rem;
    }
  }

  h3 {
    font-family: 'Brawler';
    font-weight: normal;
    line-height: 150%;
    margin-bottom: 1.5rem;
    font-size: 1.3rem;
  }

  h4 {
    font-size: 0.8rem;
    font-weight: bold;
    margin-bottom: 1.2rem;
    background: rgba($yellow-tone-3, 1);
    color: #000;
    align-self: flex-start;
    padding: 0.35rem 1rem 0.45rem 1rem;
    border-radius: 500px;
  }

  .content-block {
    h3 {
      margin-bottom: 0.5rem;
    }
  }
</style>